<template>
    <task-delivery-provider
        v-slot="{
            isDelivering,
            isLoading,
            deliverTask,
            errors,
            errorMessage,
            errorCode,
            gotoTaskStep,
            task,
            brandNetworks,
            uploadContentUrl,
            uploadedContentDeliveryUrl,
            deleteUploadedContentUrl,
            handleFileChange,
            handleResetUploads,
            handleUploadFailed,
            uploadHeaders,
            uploadedFiles,
            hasUploadedFiles,
            isFileUploading
        }"
        style="height: 100%"
    >
        <task-delivery-view
            :is-loading="isLoading"
            :is-delivering="isDelivering"
            :errors="errors"
            :error-message="errorMessage"
            :error-code="errorCode"
            :task="task"
            :brand-networks="brandNetworks"
            :upload-content-url="uploadContentUrl"
            :uploaded-content-delivery-url="uploadedContentDeliveryUrl"
            :delete-uploaded-content-url="deleteUploadedContentUrl"
            :upload-headers="uploadHeaders"
            :uploaded-files="uploadedFiles"
            :has-uploaded-files="hasUploadedFiles"
            :is-file-uploading="isFileUploading"
            @file-change="handleFileChange"
            @reset-uploads="handleResetUploads"
            @upload-failed="handleUploadFailed"
            @deliver="deliverTask"
            @exit="gotoTaskStep"
        />
    </task-delivery-provider>
</template>

<script>
    import TaskDeliveryView from '../data-views/proposals/TaskDeliveryView.vue';
    import TaskDeliveryProvider from '../providers/TaskDeliveryProvider.vue';

    export default {
        name: 'TaskDeliveryRouterView',
        components: {
            TaskDeliveryProvider,
            TaskDeliveryView
        }
    };
</script>
